import { render } from "./KeyProjects.vue?vue&type=template&id=3169686b&scoped=true&ts=true"
import script from "./KeyProjects.vue?vue&type=script&lang=ts"
export * from "./KeyProjects.vue?vue&type=script&lang=ts"

import "./KeyProjects.vue?vue&type=style&index=0&id=3169686b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3169686b"]])

export default __exports__